export enum DocumentTypeEnum {
  Init = 0, // Note: Original had typo "Inıt", corrected to "Init"
  Scanner3D = 1,
  XRay,
  CBCT,
  PictureInMounth,
  PictureInFace,
  TreatmentPlan,
  LabReport,
  Other
}
